import moment from "moment"

export const LabelDetail = ({ children }) => {
  return (
    <p className=' font-roboto text-sm font-normal text-gray-100 mt-4'> {children} </p>
  )
}

export const ValueDetail = ({ children }) => {
  return (
    <p className=' font-roboto text-xl font-medium text-black-300 break-words'> { children } </p>
  )
}

export const ValueImage = ({ sources, alt, onViewDetailPhoto }) => {
  return (
    <div 
      className={`border - 2 p-5 rounded-[5px] w-36 h-36 mt-1 flex justify-center cursor-pointer`.concat(sources ? "" : " items-center")}
      onClick={onViewDetailPhoto}
      >
      {
        sources ? (
          <img src={sources} alt={alt} />
        ) : <span className="text-xs font-semibold opacity-30">No Photo</span>
      }
    </div>
  )
}

export const ValueMSS = ({ data }) => {
  return (
    data ? (
      <div className=" flex flex-wrap gap-1" >
        {
          data.map((item, index) => {
            return (
              <div key={index} className="bg-red-200 px-2 rounded-3xl">
                <p className=" font-roboto-medium text-lg font-normal text-white-100"> {item.data} </p>
              </div>
            )
          })
        }
      </div>
    ) :
      (
        <p> - </p>
      )
  )
}

export const DetailMSSName = ({ data }) => {
  return (
    data ? (
      <div className=" flex flex-wrap gap-1" >
        {
          data.map((item, index) => {
            return (
              <div key={index} className="bg-red-200 px-2 rounded-3xl">
                <p className=" font-roboto-medium text-lg font-normal text-white-100"> {item.name} </p>
              </div>
            )
          })
        }
      </div>
    ) :
      (
        <p> - </p>
      )
  )
}

export const DetailDayOff = ({ data }) => {
  return (
    data ? (
      <div className=" flex flex-wrap gap-1" >
        {
          data.map((item, index) => {
            return (
              <div key={index} className="bg-red-200 px-2 rounded-3xl">
                <p className=" font-roboto-medium text-lg font-normal text-white-100"> {item} </p>
              </div>
            )
          })
        }
      </div>
    ) :
      (
        <p> - </p>
      )
  )
}

export const ValueDetailUnit = ({ children }) => {
  return (
    <p className=' font-roboto text-xl font-medium text-black-300'> { children } m<sup>3</sup></p>
  )
}

export const ValueDetailDate = ({ children }) => {
  return (
    <p className=' font-roboto text-xl font-medium text-black-300 break-words'> { children ? moment(children).format('DD MMMM YYYY') : '-' } </p>
  )
}